import { useEventListener } from '@vueuse/core';
import { GeneralModal } from '@/views/components/modals/GeneralModal';

const MODAL_ID = 'video-modal';
const TRIGGER_SELECTOR = '.modal-video-component__trigger';

class VideoModal extends GeneralModal {
    constructor() {
        super({
            modalId: MODAL_ID,
            triggerSelector: TRIGGER_SELECTOR,
        });
    }

    /**
     * This function prevents duplicate event listeners by ensuring the file only runs once.
     * The issue arises due to the use of `remoteModalOpen`,
     * which can cause the script to execute multiple times, leading to event duplication.
     */
    public static handleCodeIdentifier(): boolean {
        const identifier = `data-code-identifier-${MODAL_ID}`;

        if (document.body.getAttribute(identifier)) {
            return true;
        }

        document.body.setAttribute(identifier, 'true');

        return false;
    }
}

const videoModal = new VideoModal();

useEventListener(document, 'DOMContentLoaded', () => {
    if (VideoModal.handleCodeIdentifier()) {
        return;
    }
    videoModal.initialize();
});

export const remoteVideoModalOpen = (fakeTriggerElement: HTMLDivElement) => {
    videoModal.remoteModalOpen(fakeTriggerElement);
};
